module.exports = __webpack_public_path__ + "7eec53451be4913b055c2f12befaecc9.svg";